import { useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  if (location.pathname !== '/') return <footer data-testid='footer' />;

  const eNamadSize = 70;
  const eNamadId = '486573';
  const eNamadCode = 'SyoNQOCYFzQUBM2N9GGXS3XP1jJMzrUP';

  return (
    <footer data-testid='footer' className='z-50 w-screen'>
      <div className='flex justify-end'>
        <div id='samandehi' className={`h-[${eNamadSize}px] m-3 w-[${eNamadSize}px]`}></div>
        <div id='e-namad' className={`h-[${eNamadSize}px] m-3 w-[${eNamadSize}px]`}>
          <a
            referrerPolicy='origin'
            target='_blank'
            href={`https://trustseal.enamad.ir/?id=${eNamadId}&Code=${eNamadCode}`}
          >
            <img
              id={eNamadCode}
              referrerPolicy='origin'
              src={`https://trustseal.enamad.ir/logo.aspx?id=${eNamadId}&Code=${eNamadCode}`}
              alt='e-namad'
              width={eNamadSize}
              height={eNamadSize}
              className='cursor-pointer'
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
